import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class EventRefundSplit extends AppRecord {
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }

  get castedEvent(){
    return this.constructor.employeeStore.controllers.EventsController.setNewDatum(this.event)
  }
}
export default EventRefundSplit
